import { render, staticRenderFns } from "./T1GTabs.vue?vue&type=template&id=e7335b30&scoped=true&"
import script from "./T1GTabs.vue?vue&type=script&lang=js&"
export * from "./T1GTabs.vue?vue&type=script&lang=js&"
import style0 from "./T1GTabs.vue?vue&type=style&index=0&id=e7335b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7335b30",
  null
  
)

export default component.exports